var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#0863F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0468 20.7476V14.6006H17.1205L17.4288 12.1939H15.0468V10.6609C15.0468 9.96638 15.2403 9.49088 16.237 9.49088H17.5V7.34513C16.8855 7.27928 16.2678 7.24748 15.6498 7.24988C13.8168 7.24988 12.5583 8.36888 12.5583 10.4231V12.1894H10.498V14.5961H12.5628V20.7476H15.0468Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.4164910aed26487e756ca55eaed7b398.svg";
export { ForwardRef as ReactComponent };